import React from "react";
import Helmet from "react-helmet";

export default class ContactPage extends React.Component
{
    render () {
        return (
            <article>
                <Helmet title="Kontakt" />

                <h1>Kontakt</h1>

                <p>
                    Betreiber der Website und Verantwortlicher gemäß Datenschutz-Grundverordnung:
                </p>

                <address>
                    Risag e.U.
                    <br />
                    Günther Allgäuer
                    <br />
                    <br />
                    Kronenweg 1a
                    <br />
                    6800 Feldkirch
                    <br />
                    Vorarlberg, Österreich
                </address>

                <p>
                    <span className="is-hidden-sm">Telefon: </span>

                    <a href="tel:+436605354277">+43 660 53 54 277</a>
                </p>

                <p>
                    <span className="is-hidden-sm">E-Mail: </span>

                    <a href="mailto:info@risag.eu">info@risag.eu</a>

                    <span className="is-hidden-sm"> oder </span>
                    <span className="is-hidden-lg"><br /></span>

                    <a href="mailto:werkstatt@scharfe-klinge.at">werkstatt@scharfe-klinge.at</a>
                </p>

                <h2>Datenschutzerklärung</h2>

                <p>
                    Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von
                    personenbezogenen Daten (nachfolgend kurz „Daten“) innerhalb unseres Onlineangebotes und der
                    mit ihm verbundenen Webseiten, Funktionen und Inhalte (nachfolgend gemeinsam bezeichnet als
                    „Onlineangebot“).
                </p>

                <p>
                    Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. „Verarbeitung“ oder „Verantwortlicher“
                    verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).
                </p>

                <h3>Arten der verarbeiteten Daten</h3>

                <ul>
                    <li>Bestandsdaten (z.B., Namen, Adressen).</li>
                    <li>Kontaktdaten (z.B., E-Mail, Telefonnummern).</li>
                    <li>Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).</li>
                    <li>Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).</li>
                    <li>Meta-/Kommunikationsdaten (z.B., Geräte-Informationen, IP-Adressen).</li>
                </ul>

                <h3>Kategorien betroffener Personen</h3>

                <p>
                    Besucher und Nutzer des Onlineangebotes und Kunden der Risag e.U.
                </p>

                <p>
                    Nachfolgend bezeichnen wir die betroffenen Personen zusammenfassend auch als „Nutzer“.
                </p>

                <h3>Zweck der Verarbeitung</h3>

                <ul>
                    <li>Zurverfügungstellung des Onlineangebotes, seiner Funktionen und Inhalte.</li>
                    <li>Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.</li>
                    <li>Sicherheitsmaßnahmen.</li>
                </ul>

                <h3>Verwendete Begrifflichkeiten</h3>

                <p>
                    „Personenbezogene Daten“ sind alle Informationen, die sich auf eine identifizierte oder identifizierbare
                    natürliche Person (im Folgenden „betroffene Person“) beziehen; als identifizierbar wird eine natürliche
                    Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem
                    Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung (z.B. Cookie) oder zu einem oder
                    mehreren besonderen Merkmalen identifiziert werden kann, die Ausdruck der physischen, physiologischen,
                    genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identität dieser natürlichen
                    Person sind.
                </p>

                <p>
                    „Verarbeitung“ ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführte Vorgang oder jede
                    solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit und
                    umfasst praktisch jeden Umgang mit Daten.
                </p>

                <p>
                    „Pseudonymisierung“ die Verarbeitung personenbezogener Daten in einer Weise, dass die personenbezogenen
                    Daten ohne Hinzuziehung zusätzlicher Informationen nicht mehr einer spezifischen betroffenen Person
                    zugeordnet werden können, sofern diese zusätzlichen Informationen gesondert aufbewahrt werden und
                    technischen und organisatorischen Maßnahmen unterliegen, die gewährleisten, dass die personenbezogenen
                    Daten nicht einer identifizierten oder identifizierbaren natürlichen Person zugewiesen werden.
                </p>

                <p>
                    Als „Verantwortlicher“ wird die natürliche oder juristische Person, Behörde, Einrichtung oder andere
                    Stelle, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
                    personenbezogenen Daten entscheidet, bezeichnet.
                </p>

                <p>
                    „Auftragsverarbeiter“ eine natürliche oder juristische Person, Behörde, Einrichtung oder andere
                    Stelle, die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet.
                </p>


                <h3>Maßgebliche Rechtsgrundlagen</h3>

                <p>
                    Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen
                    mit.
                </p>

                <p>
                    Sofern die Rechtsgrundlage in der Datenschutzerklärung nicht genannt wird, gilt Folgendes:
                </p>

                <ul>
                    <li>
                        Die Rechtsgrundlage für die Einholung von Einwilligungen ist
                        Art. 6 Abs. 1 lit. a und Art. 7 DSGVO.
                    </li>

                    <li>
                        Die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung
                        vertraglicher Maßnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO.
                    </li>

                    <li>
                        Die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen Verpflichtungen ist
                        Art. 6 Abs. 1 lit. c DSGVO.
                    </li>

                    <li>
                        Und die Rechtsgrundlage für die Verarbeitung zur Wahrung unserer berechtigten Interessen ist
                        Art. 6 Abs. 1 lit. f DSGVO.
                    </li>
                </ul>

                <p>
                    Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen
                    Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient
                    Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.
                </p>

                <h3>Sicherheitsmaßnahmen</h3>

                <p>
                    Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung des Stands der Technik, der Implementierungskosten
                    und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der unterschiedlichen
                    Eintrittswahrscheinlichkeit und Schwere des Risikos für die Rechte und Freiheiten natürlicher Personen,
                    geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten.
                </p>

                <p>
                    Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit, Integrität und Verfügbarkeit
                    von Daten durch Kontrolle des physischen Zugangs zu den Daten, als auch des sie betreffenden
                    Zugriffs, der Eingabe, Weitergabe, der Sicherung der Verfügbarkeit und ihrer Trennung.

                    Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, Löschung
                    von Daten und Reaktion auf Gefährdung der Daten gewährleisten.

                    Ferner berücksichtigen wir den Schutz personenbezogener Daten bereits bei der Entwicklung, bzw.
                    Auswahl von Hardware, Software sowie Verfahren, entsprechend dem Prinzip des Datenschutzes durch
                    Technikgestaltung und durch datenschutzfreundliche Voreinstellungen (Art. 25 DSGVO).
                </p>

                <h3>Zusammenarbeit mit Auftragsverarbeitern und Dritten</h3>

                <p>
                    Sofern wir im Rahmen unserer Verarbeitung Daten gegenüber anderen Personen und Unternehmen (Auftragsverarbeitern
                    oder Dritten) offenbaren, sie an diese übermitteln oder ihnen sonst Zugriff auf die Daten gewähren,
                    erfolgt dies nur auf Grundlage einer gesetzlichen Erlaubnis (z.B. wenn eine Übermittlung der Daten
                    an Dritte, wie an Zahlungsdienstleister, gem. Art. 6 Abs. 1 lit. b DSGVO zur Vertragserfüllung
                    erforderlich ist), Sie eingewilligt haben, eine rechtliche Verpflichtung dies vorsieht oder auf
                    Grundlage unserer berechtigten Interessen (z.B. beim Einsatz von Beauftragten, Webhostern, etc.).
                </p>

                <p>
                    Sofern wir Dritte mit der Verarbeitung von Daten auf Grundlage eines sog.
                    „Auftragsverarbeitungsvertrages“ beauftragen, geschieht dies auf Grundlage des Art. 28 DSGVO.
                </p>

                <h3>Übermittlungen in Drittländer</h3>

                <p>
                    Sofern wir Daten in einem Drittland (d.h. außerhalb der Europäischen Union (EU) oder des
                    Europäischen Wirtschaftsraums (EWR)) verarbeiten oder dies im Rahmen der Inanspruchnahme von
                    Diensten Dritter oder Offenlegung, bzw. Übermittlung von Daten an Dritte geschieht, erfolgt dies
                    nur, wenn es zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung,
                    aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht.

                    Vorbehaltlich gesetzlicher oder vertraglicher Erlaubnisse, verarbeiten oder lassen wir die Daten in
                    einem Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art. 44 ff. DSGVO verarbeiten.
                    D.h. die Verarbeitung erfolgt z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten
                    Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. für die USA durch das
                    „Privacy Shield“) oder Beachtung offiziell anerkannter spezieller vertraglicher Verpflichtungen
                    (so genannte „Standardvertragsklauseln“).
                </p>

                <h3>Rechte der betroffenen Personen</h3>

                <ul>
                    <li>
                        Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob betreffende Daten verarbeitet werden
                        und auf Auskunft über diese Daten sowie auf weitere Informationen und Kopie der Daten entsprechend
                        Art. 15 DSGVO.
                    </li>

                    <li>
                        Sie haben entsprechend. Art. 16 DSGVO das Recht, die Vervollständigung der Sie betreffenden Daten
                        oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.
                    </li>

                    <li>
                        Sie haben nach Maßgabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten unverzüglich
                        gelöscht werden, bzw. alternativ nach Maßgabe des Art. 18 DSGVO eine Einschränkung der Verarbeitung
                        der Daten zu verlangen.
                    </li>

                    <li>
                        Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt
                        haben nach Maßgabe des Art. 20 DSGVO zu erhalten und deren Übermittlung an andere Verantwortliche zu fordern.
                    </li>

                    <li>
                        Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zuständigen
                        Aufsichtsbehörde einzureichen.
                    </li>
                </ul>

                <h3>Widerrufsrecht</h3>

                <p>
                    Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung für die Zukunft
                    zu widerrufen.
                </p>

                <h3>Widerspruchsrecht</h3>

                <p>
                    Sie können der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21 DSGVO
                    jederzeit widersprechen.
                </p>

                <h3>Cookies und Widerspruchsrecht bei Direktwerbung</h3>

                <p>
                    Als „Cookies“ werden kleine Dateien bezeichnet, die auf Rechnern der Nutzer gespeichert werden.

                    Innerhalb der Cookies können unterschiedliche Angaben gespeichert werden. Ein Cookie dient primär
                    dazu, die Angaben zu einem Nutzer (bzw. dem Gerät auf dem das Cookie gespeichert ist) während oder
                    auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern.

                    Als temporäre Cookies, bzw. „Session-Cookies“ oder „transiente Cookies“, werden Cookies bezeichnet,
                    die gelöscht werden, nachdem ein Nutzer ein Onlineangebot verlässt und seinen Browser schließt. In
                    einem solchen Cookie kann z.B. der Inhalt eines Warenkorbs in einem Onlineshop oder ein Login-Status
                    gespeichert werden.

                    Als „permanent“ oder „persistent“ werden Cookies bezeichnet, die auch nach dem Schließen des Browsers
                    gespeichert bleiben. So kann z.B. der Login-Status gespeichert werden, wenn die Nutzer diese nach
                    mehreren Tagen aufsuchen. Ebenso können in einem solchen Cookie die Interessen der Nutzer gespeichert
                    werden, die für Reichweitenmessung oder Marketingzwecke verwendet werden.

                    Als „Third-Party-Cookie“ werden Cookies bezeichnet, die von anderen Anbietern als dem Verantwortlichen,
                    der das Onlineangebot betreibt, angeboten werden (andernfalls, wenn es nur dessen Cookies sind
                    spricht man von „First-Party Cookies“).
                </p>

                <p>
                    Wir können temporäre und permanente Cookies einsetzen und klären hierüber im Rahmen unserer
                    Datenschutzerklärung auf.
                </p>

                <p>
                    Falls die Nutzer nicht möchten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie
                    gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren.

                    Gespeicherte Cookies können in den Systemeinstellungen des Browsers gelöscht werden.

                    Der Ausschluss von Cookies kann zu Funktionseinschränkungen dieses Onlineangebotes führen.
                </p>

                <h3>Löschung von Daten</h3>

                <p>
                    Die von uns verarbeiteten Daten werden nach Maßgabe der Art. 17 und 18 DSGVO gelöscht oder in ihrer
                    Verarbeitung eingeschränkt. Sofern nicht im Rahmen dieser Datenschutzerklärung ausdrücklich
                    angegeben, werden die bei uns gespeicherten Daten gelöscht, sobald sie für ihre Zweckbestimmung
                    nicht mehr erforderlich sind und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen.

                    Sofern die Daten nicht gelöscht werden, weil sie für andere und gesetzlich zulässige Zwecke
                    erforderlich sind, wird deren Verarbeitung eingeschränkt. D.h. die Daten werden gesperrt und nicht
                    für andere Zwecke verarbeitet. Das gilt z.B. für Daten, die aus handels- oder steuerrechtlichen
                    Gründen aufbewahrt werden müssen.
                </p>

                <p>
                    Nach gesetzlichen Vorgaben in Österreich erfolgt die Aufbewahrung insbesondere für 7 Jahre gemäß
                    § 132 Abs. 1 BAO (Buchhaltungsunterlagen, Belege/Rechnungen, Konten, Belege, Geschäftspapiere,
                    Aufstellung der Einnahmen und Ausgaben, etc.), für 22 Jahre im Zusammenhang mit Grundstücken und
                    für 10 Jahre bei Unterlagen im Zusammenhang mit elektronisch erbrachten Leistungen,
                    Telekommunikations-, Rundfunk- und Fernsehleistungen, die an Nichtunternehmer in EU-Mitgliedstaaten
                    erbracht werden und für die der Mini-One-Stop-Shop (MOSS) in Anspruch genommen wird.
                </p>

                <h3>Vertragliche Leistungen</h3>

                <p>
                    Wir verarbeiten die Daten unserer Vertragspartner und Interessenten sowie anderer Auftraggeber,
                    Kunden, Mandanten, Klienten oder Vertragspartner (einheitlich bezeichnet als „Vertragspartner“)
                    entsprechend Art. 6 Abs. 1 lit. b. DSGVO, um ihnen gegenüber unsere vertraglichen oder
                    vorvertraglichen Leistungen zu erbringen. Die hierbei verarbeiteten Daten, die Art, der Umfang und
                    der Zweck und die Erforderlichkeit ihrer Verarbeitung, bestimmen sich nach dem zugrundeliegenden Vertragsverhältnis.
                </p>

                <p>
                    Zu den verarbeiteten Daten gehören die Stammdaten unserer Vertragspartner (z.B., Namen und Adressen),
                    Kontaktdaten (z.B. E-Mailadressen und Telefonnummern) sowie Vertragsdaten (z.B., in Anspruch genommene
                    Leistungen, Vertragsinhalte, vertragliche Kommunikation, Namen von Kontaktpersonen) und Zahlungsdaten
                    (z.B., Bankverbindungen, Zahlungshistorie).
                </p>

                <p>
                    Besondere Kategorien personenbezogener Daten verarbeiten wir grundsätzlich nicht, außer wenn diese
                    Bestandteile einer beauftragten oder vertragsgemäßen Verarbeitung sind.
                </p>

                <p>
                    Wir verarbeiten Daten, die zur Begründung und Erfüllung der vertraglichen Leistungen erforderlich
                    sind und weisen auf die Erforderlichkeit ihrer Angabe, sofern diese für die Vertragspartner nicht
                    evident ist, hin. Eine Offenlegung an externe Personen oder Unternehmen erfolgt nur, wenn sie im
                    Rahmen eines Vertrags erforderlich ist.

                    Bei der Verarbeitung der uns im Rahmen eines Auftrags überlassenen Daten, handeln wir entsprechend
                    den Weisungen der Auftraggeber sowie der gesetzlichen Vorgaben.
                </p>

                <p>
                    Im Rahmen der Inanspruchnahme unserer Onlinedienste, können wir die IP-Adresse und den Zeitpunkt der
                    jeweiligen Nutzerhandlung speichern. Die Speicherung erfolgt auf Grundlage unserer berechtigten
                    Interessen, als auch der Interessen der Nutzer am Schutz vor Missbrauch und sonstiger unbefugter
                    Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, außer sie ist zur
                    Verfolgung unserer Ansprüche gem. Art. 6 Abs. 1 lit. f. DSGVO erforderlich oder es besteht hierzu
                    eine gesetzliche Verpflichtung gem. Art. 6 Abs. 1 lit. c. DSGVO.
                </p>

                <p>
                    Die Löschung der Daten erfolgt, wenn die Daten zur Erfüllung vertraglicher oder gesetzlicher
                    Fürsorgepflichten sowie für den Umgang mit etwaigen Gewährleistungs- und vergleichbaren Pflichten
                    nicht mehr erforderlich sind, wobei die Erforderlichkeit der Aufbewahrung der Daten alle drei Jahre
                    überprüft wird; im Übrigen gelten die gesetzlichen Aufbewahrungspflichten.
                </p>

                <h3>Administration, Finanzbuchhaltung, Büroorganisation, Kontaktverwaltung</h3>

                <p>
                    Wir verarbeiten Daten im Rahmen von Verwaltungsaufgaben sowie Organisation unseres Betriebs,
                    Finanzbuchhaltung und Befolgung der gesetzlichen Pflichten, wie z.B. der Archivierung.

                    Hierbei verarbeiten wir dieselben Daten, die wir im Rahmen der Erbringung unserer vertraglichen
                    Leistungen verarbeiten.

                    Die Verarbeitungsgrundlagen sind Art. 6 Abs. 1 lit. c. DSGVO, Art. 6 Abs. 1 lit. f. DSGVO.

                    Von der Verarbeitung sind Kunden, Interessenten, Geschäftspartner und Websitebesucher betroffen. Der
                    Zweck und unser Interesse an der Verarbeitung liegt in der Administration, Finanzbuchhaltung,
                    Büroorganisation, Archivierung von Daten, also Aufgaben die der Aufrechterhaltung unserer
                    Geschäftstätigkeiten, Wahrnehmung unserer Aufgaben und Erbringung unserer Leistungen dienen.

                    Die Löschung der Daten im Hinblick auf vertragliche Leistungen und die vertragliche Kommunikation
                    entspricht den, bei diesen Verarbeitungstätigkeiten genannten Angaben.
                </p>

                <p>
                    Wir offenbaren oder übermitteln hierbei Daten an die Finanzverwaltung, Berater, wie z.B.,
                    Steuerberater oder Wirtschaftsprüfer sowie weitere Gebührenstellen und Zahlungsdienstleister.
                </p>

                <p>
                    Ferner speichern wir auf Grundlage unserer betriebswirtschaftlichen Interessen Angaben zu
                    Lieferanten, Veranstaltern und sonstigen Geschäftspartnern, z.B. zwecks späterer Kontaktaufnahme.

                    Diese mehrheitlich unternehmensbezogenen Daten, speichern wir grundsätzlich dauerhaft.
                </p>

                <h3>Hosting und E-Mail-Versand</h3>

                <p>
                    Die von uns in Anspruch genommenen Hosting-Leistungen dienen der Zurverfügungstellung der folgenden
                    Leistungen: Infrastruktur- und Plattformdienstleistungen, Rechenkapazität, Speicherplatz und
                    Datenbankdienste, E-Mail-Versand, Sicherheitsleistungen sowie technische Wartungsleistungen, die wir
                    zum Zwecke des Betriebs dieses Onlineangebotes einsetzen.
                </p>

                <p>
                    Hierbei verarbeiten wir, bzw. unser Hostinganbieter Bestandsdaten, Kontaktdaten, Inhaltsdaten,
                    Vertragsdaten, Nutzungsdaten, Meta- und Kommunikationsdaten von Kunden, Interessenten und Besuchern
                    dieses Onlineangebotes auf Grundlage unserer berechtigten Interessen an einer effizienten und
                    sicheren Zurverfügungstellung dieses Onlineangebotes gem.
                    Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO (Abschluss Auftragsverarbeitungsvertrag).
                </p>

                <h3>Erhebung von Zugriffsdaten und Logfiles</h3>

                <p>
                    Wir, bzw. unser Hostinganbieter, erhebt auf Grundlage unserer berechtigten Interessen im Sinne des
                    Art. 6 Abs. 1 lit. f. DSGVO Daten über jeden Zugriff auf den Server, auf dem sich dieser Dienst
                    befindet (sogenannte Serverlogfiles).

                    Zu den Zugriffsdaten gehören Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs,
                    übertragene Datenmenge, Meldung über erfolgreichen Abruf, Browsertyp nebst Version, das
                    Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider.
                </p>

                <p>
                    Logfile-Informationen werden aus Sicherheitsgründen (z.B. zur Aufklärung von Missbrauchs- oder
                    Betrugshandlungen) für die Dauer von maximal 7 Tagen gespeichert und danach gelöscht.

                    Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endgültigen
                    Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.
                </p>

                <h3>Einbindung von Diensten und Inhalten Dritter</h3>

                <p>
                    Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h.
                    Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne
                    des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren
                    Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als „Inhalte“).
                </p>

                <p>
                    Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer
                    wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden könnten.

                    Die IP-Adresse ist damit für die Darstellung dieser Inhalte erforderlich.

                    Wir bemühen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich
                    zur Auslieferung der Inhalte verwenden. Drittanbieter können ferner so genannte Pixel-Tags
                    (unsichtbare Grafiken, auch als „Web Beacons“ bezeichnet) für statistische oder Marketingzwecke
                    verwenden. Durch die „Pixel-Tags“ können Informationen, wie der Besucherverkehr auf den Seiten
                    dieser Website ausgewertet werden. Die pseudonymen Informationen können ferner in Cookies auf dem
                    Gerät der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und
                    Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres
                    Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden.
                </p>

                <h3>Google Fonts</h3>

                <p>
                    Wir binden die Schriftarten („Google Fonts“) des Anbieters <em>Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA</em>, ein.
                </p>

                <p>
                    Datenschutzerklärung: <a href="https://www.google.com/policies/privacy/" target="_blank">https://www.google.com/policies/privacy/</a>.
                </p>

                <h3>Google Maps</h3>

                <p>
                    Wir binden die Landkarten des Dienstes „Google Maps“ des Anbieters <em>Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA</em>, ein.
                </p>

                <p>
                    Zu den verarbeiteten Daten können insbesondere IP-Adressen und Standortdaten der Nutzer gehören, die
                    jedoch nicht ohne deren Einwilligung (im Regelfall im Rahmen der Einstellungen ihrer Mobilgeräte
                    vollzogen), erhoben werden. Die Daten können in den USA verarbeitet werden.
                </p>

                <p>
                    Datenschutzerklärung: <a href="https://www.google.com/policies/privacy/" target="_blank">https://www.google.com/policies/privacy/</a>.
                </p>

                <hr />

                <p>
                    <em>Vom Websiteinhaber angepasst</em>

                    <br />

                    <a href="https://datenschutz-generator.de" rel="nofollow" target="_blank">
                        Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke
                    </a>
                </p>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/kontakt.js